import type { FollowupModel } from "./FollowupModel";
import type { FollowUpSheet, Dive } from "./Followup.typed";

export class FollowupAdapter {
  constructor(private model: FollowupModel) {}
  async getFollowUpSheet(
    templateId: number,
    customerId: number,
  ): Promise<FollowUpSheet | undefined> {
    return this.model.getFollowUpSheet(templateId, customerId);
  }
  async createFollowUpSheet(sheet: FollowUpSheet): Promise<void> {
    return this.model.createFollowUpSheet(sheet);
  }
  async updateFollowUpSheet(sheet: FollowUpSheet): Promise<FollowUpSheet> {
    return this.model.updateFollowUpSheet(sheet);
  }
  async getDives(templateId: number, customerId: number): Promise<Dive[]> {
    return this.model.getDives(templateId, customerId);
  }
  async updateDives(templateId: number, customerId: number, dives: Dive[]): Promise<Dive[]> {
    return this.model.updateDives(templateId, customerId, dives);
  }
}
